export default "__VITE_ASSET__8a3539d1__"